/** screen: English + Arabic (Arabic is a draft for native review). Generated/merged by the i18n helper; edit freely. */
const en = {
  "unpairedTitle": "No device paired",
  "unpairedBody": "This player isn't linked to a screen, so nothing plays on it. Pair a device to show its content; its status and details appear here once it connects.",
  "notPaired": "Not paired",
  "searchPlays": "Search by item or layout",
  "fRange": "Period",
  "r24h": "Last 24 hours",
  "r7d": "Last 7 days",
  "r30d": "Last 30 days",
  "r90d": "Last 90 days",
  "fAllTypes": "All playback types",
  "fKind": "Content type",
  "fAllKinds": "All content",
  "k_video": "Videos",
  "k_image": "Images",
  "k_widget": "Apps",
  "k_app": "Custom apps",
  "k_pdf": "PDFs",
  "k_composition": "Compositions",
  "clearFilters": "Clear filters",
  "nPlays": "{n} plays | {n} play | {n} plays",
  "nPlaysCapped": "{n}+ plays",
  "noPlaysMatch": "No plays match. Try another search, period or filter.",
  "tStatus": "Player Status",
  "tPublished": "Play queue",
  "tActivity": "Player Activity",
  "tResources": "Resource Usage",
  "tLogs": "Errors & Warnings",
  "tLive": "Live Control",
  "tInteractivity": "Interactivity",
  "tSettings": "Player Settings",
  "tManifest": "Manifest",
  "backPlayers": "← Players",
  "player": "Player",
  "downloadingPct": "Downloading content {pct} %",
  "downloadingLine": "Downloading content: {pct} % · {done} of {total} files · {got} of {size}",
  "online": "Online",
  "offline": "Offline",
  "sections": "Player sections",
  "dH": "{d} d {h} h",
  "hM": "{h} h {m} min",
  "m": "{m} min",
  "s": "{s} s",
  "never": "never",
  "justNow": "just now",
  "ago": "{d} ago",
  "fb_no_manifest": "no content published yet",
  "fb_no_active_schedule": "nothing scheduled right now",
  "fb_assets_pending": "content still downloading",
  "fb_asset_verification_failed": "a file failed verification",
  "fb_decoder_error": "decoder error",
  "fb_storage_full": "storage full",
  "aName": "Player name",
  "aModel": "Device model",
  "aOs": "Operating system",
  "aVersion": "Player version",
  "aResolution": "Screen resolution",
  "aMac": "MAC address",
  "aNotReported": "Not reported by the OS",
  "aLocalIp": "Local IP",
  "aPublicIp": "Public IP",
  "aPaired": "Paired",
  "aNotPaired": "Not paired",
  "setupTitle": "Device setup",
  "setupAllSet": "All set",
  "setupMissing": "1 thing not allowed | {n} things not allowed",
  "setupUnknown": "This player's app doesn't report its setup yet. Update the app on the screen to see it here.",
  "permAllowed": "Allowed",
  "permNotAllowed": "Not allowed",
  "setupNeeds": "Needs attention",
  "fixDirect": "Allow remotely",
  "fixAsk": "Ask on screen",
  "fixDirectHint": "Applied on the player now — nobody needs to be there.",
  "fixAskHint": "Shows Android's prompt on the screen; someone there taps Allow.",
  "fixApplying": "Applying… (updates within a minute)",
  "fixWaiting": "Waiting for someone at the screen to accept…",
  "fixAllDirect": "Fix all remotely",
  "fixAllAsk": "Fix all on screen",
  "fixSentDirect": "Sent: the player is allowing it now",
  "fixSentAsk": "Sent: the prompt is on the screen — someone there needs to accept it",
  "fixFailed": "Couldn't reach the player",
  "setupOk": "Allowed",
  "setupImpact": "What this means:",
  "setupHowFix": "How to fix:",
  "perm_fix_capture": "Start Live View, then ask someone at the screen to tap “Start now” in the box that appears. It's also a step in the setup wizard.",
  "perm_root": "Root access (used for silent updates, reboot and restarting by itself)",
  "perm_root_off": "",
  "perm_remoteTouch": "Live View can touch the whole screen",
  "perm_remoteTouch_off": "Taps and swipes in Live View only reach Displaro, not other apps or the home screen.",
  "perm_fullScreenCapture": "Live View shows the whole screen",
  "perm_fullScreenCapture_off": "Live View shows only Displaro, not other apps or the home screen. Android asks again for this after the player restarts.",
  "perm_autoStart": "Starts by itself after a reboot or power cut",
  "perm_autoStart_off": "After a power cut or restart the screen stays on Android until someone opens Displaro (a “Tap to resume” reminder appears if notifications are allowed).",
  "perm_batteryUnrestricted": "Never put to sleep by Android",
  "perm_batteryUnrestricted_off": "On some devices Android may pause or stop Displaro during long playback to save power.",
  "perm_installUpdates": "Installs updates with one tap",
  "perm_installUpdates_off": "When a new version arrives, someone at the screen first has to allow Displaro to install apps before updating.",
  "perm_notifications": "Can show a “Tap to resume” reminder",
  "perm_notifications_off": "If Displaro can't come back by itself, no reminder appears on the screen.",
  "perm_deviceOwner": "Kiosk mode (Device Owner)",
  "perm_deviceOwner_off": "Remote reboot isn't available, people can leave the player with the Home button, and app updates need a tap on the screen.",
  "perm_fix_wizard": "Fix it on the screen: restart Displaro and choose “Allow” in the setup that appears.",
  "perm_fix_owner": "Set up once on a freshly reset device with the kiosk setup QR, or ask your installer for a pre-configured device.",
  "about": "About Player",
  "idLabel": "ID {id}",
  "time": "Time",
  "localTime": "Local time at the screen · {tz}",
  "lastSeen": "Last seen",
  "uptime": "Uptime",
  "lastSync": "Last content sync",
  "lastCheck": "Last manifest check",
  "other": "Other Details",
  "noHeartbeat": "No heartbeat received yet — details appear once the player reports in.",
  "connection": "Connection",
  "onlineDot": "● Online",
  "copy": "Copy",
  "waitingPlays": "None | {n} play | {n} plays",
  "lastSent": "last sent {ago} · uploads every 15 min",
  "neverSent": "nothing received in the last 7 days",
  "copied": "Copied",
  "offlineDot": "○ Offline",
  "playback": "Playback",
  "playing": "Playing scheduled content",
  "notOnScreen": "but another app or the home screen is in front of it: the display isn't showing it",
  "fallbackReel": "⚠ Fallback reel",
  "starting": "Starting up",
  "content": "Content",
  "upToDate": "up to date",
  "pending": "r{rev} pending",
  "mediaFiles": "Media files",
  "filesLine": "{v} verified · {p} downloading · {f} failed",
  "storage": "Storage",
  "freeOf": "{free} free of {total}",
  "storagePct": "Storage {pct}% used",
  "contentTooBig": "Its content is {need}; this player can store about {capacity}. Make the content smaller, or use a player with more storage.",
  "appMemory": "App memory",
  "lowMemory": "· ⚠ low memory",
  "network": "Network",
  "noInternet": " (no internet)",
  "power": "Power",
  "mains": "Mains powered",
  "charging": " · charging",
  "unsent": "Plays waiting to upload",
  "buffered": "{n} buffered on the device",
  "coordsBoth": "Enter both latitude and longitude (or neither).",
  "latRange": "Latitude must be between −90 and 90.",
  "lngRange": "Longitude must be between −180 and 180.",
  "saved": "Saved",
  "locationSaved": "Location saved",
  "savedNextSync": "Saved · the player applies it on its next sync",
  "deletePrompt": "Delete “{name}” permanently? Its content list and settings are removed and its seat is freed.\n\nType the player name to confirm:",
  "nameMismatch": "The name did not match; nothing was deleted",
  "deleted": "“{name}” deleted",
  "sGeneral": "General",
  "sLocation": "Location",
  "sSchedule": "Working Schedule",
  "sDisplay": "Display",
  "sSound": "Sound",
  "sDevice": "Device",
  "discard": "You have unsaved changes. Discard them?",
  "loading": "Loading…",
  "settingsSections": "Settings sections",
  "saving": "Saving…",
  "save": "Save",
  "playerName": "Player Name",
  "timeZone": "Time zone",
  "tzHint2": "Working hours, restrictions and clocks run in this time zone.",
  "groupsTags": "Groups & tags",
  "noGroup": "No group",
  "editInPlayers": "Edit in Players",
  "notSet": "Not set",
  "latitude": "Latitude",
  "longitude": "Longitude",
  "locFromDevice": "From the player's device (±{acc})",
  "locFromIp": "Estimated from its internet address (approximate)",
  "locManual": "Set by hand",
  "locationTitle": "Location",
  "locApprox": "Approximate area",
  "changeLocation": "Change location",
  "setLocation": "Set location",
  "noLocationYet": "No location yet. The player reports it when it can, or you can set it in Player Settings.",
  "locWaiting": "Follows the player (waiting for it to report its location)",
  "useDeviceLocation": "Use the player's location instead",
  "locationFollows": "The location now follows the player",
  "locAutoHint": "Set automatically from the player's device (or roughly from its internet address); a location typed here stays until you hand it back.",
  "perm_location": "Shares its location",
  "perm_location_off": "The location can't set itself precisely: it's estimated from the internet address (often several km off) unless you type it in.",
  "locHint": "Used by Prayer Time and Weather apps set to “Player Location”.",
  "noDevice": "No device is paired to this player.",
  "cmdSent": "{what}: sent to the player",
  "cmdDone": "{what}: done",
  "cmdFailed": "{what} didn't work",
  "cmdSending": "Sending…",
  "repairHere": "Re-pair to new hardware",
  "pairHere": "Pair a device",
  "deviceCmdHint": "Restart and clear cache work on every device; a full reboot needs kiosk mode or root. To watch the screen live:",
  "openLive": "Live Control",
  "deviceActions": "Reboot · clear cache · live view",
  "repairHw": "Re-pair to new hardware (in Players → Edit)",
  "pairInPlayers": "Pair device (in Players → Edit)",
  "deleteNote": "Deleting removes this player, its content list and settings, and frees its seat. This cannot be undone.",
  "deletePlayer": "Delete player…",
  "ptPlayer": "Published to player",
  "ptGroup": "From group",
  "ptTag": "From tag",
  "ptRemoved": "Publication removed",
  "ptPlayerHint": "Played because it is published directly to this player.",
  "ptGroupHint": "Played because it is published to a player group this player belongs to.",
  "ptTagHint": "Played because it is published to a tag this player has.",
  "ptRemovedHint": "This play happened, but the publication that sent it here no longer exists: the item was unpublished or published again, or the player left that group or tag. The play still counts in reports.",
  "activityView": "Activity view",
  "events": "Events & issues",
  "playbackTab": "Playback",
  "playerActivity": "Player Activity",
  "popTimes": "Proof of play reported by the device · times in {tz}",
  "playerTz": "the player’s time zone",
  "refresh": "Refresh",
  "noPlayback": "No playback reported yet. The player buffers proof of play offline and uploads it when it’s connected.",
  "cAsset": "Asset name",
  "cType": "Playback type",
  "cDate": "Date",
  "cTime": "Time",
  "cDuration": "Duration",
  "cLayout": "Layout",
  "deletedAsset": "Deleted asset",
  "page": "Page {n}",
  "newer": "← Newer",
  "older": "Older →",
  "published": "Published.",
  "scene": "Scene",
  "layout": "Layout",
  "customAppFeeds": "custom app · {n} feed | custom app · {n} feeds",
  "recompile": "Recompile & publish",
  "settingsIn": "Name, location and settings are in",
  "noManifest": "No manifest has been published for this screen yet. It will play the embedded fallback reel until one is.",
  "revisionTitle": "Manifest revision {n}",
  "verified": "verified",
  "canvas": "canvas",
  "media": "media",
  "nothingScheduled": "Nothing is scheduled: the screen plays its embedded fallback reel.",
  "entersWith": "enters with {tr}",
  "inSequence": "{len} in a sequence",
  "nItemsZone": "{role} · {n} item(s)",
  "loop": "Loop",
  "nothingPublished": "Nothing published — embedded fallback reel.",
  "item": "Item",
  "restricted": "restricted",
  "playsOnce": "Plays once and holds the last item.",
  "peak": "Peak",
  "samples": "Samples",
  "slowest": "Slowest",
  "offlineSamples": "Offline samples",
  "nOfM": "{n} of {m}",
  "ms": "{n} ms",
  "cpu": "CPU",
  "memory": "Memory",
  "disk": "Disk",
  "per5": "{what} per 5 minutes · last 24 hours",
  "perHour": "{what} per hour · last 7 days",
  "timeRange": "Time range",
  "last24": "Last 24 hours",
  "last7": "Last 7 days",
  "sampledEvery": "Sampled every minute on the device · kept {days} days · times in {tz}",
  "playerTime": "player time",
  "noSamples": "No resource samples in this period. Players upload metrics in batches when they are online — check back after the screen reports in.",
  "peakIn": "Peak in period: {v}",
  "connectivity": "Connectivity",
  "offlineWarn": "⚠ Offline",
  "onlinePct": "Online in {pct}% of samples",
  "stale": "Latest sample is {ago} ({at}) — the player may be offline or powered off.",
  "cpuUsage": "CPU usage",
  "average": "Average",
  "ram": "Memory (RAM)",
  "diskUsage": "Disk usage",
  "highest": "Highest",
  "pingTitle": "Connectivity (round trip to the API)",
  "avgLatency": "Average latency",
  "showTable": "Show data table",
  "hideTable": "Hide data table",
  "periodStart": "Period start",
  "cpuAvgPeak": "CPU avg / peak",
  "memAvgPeak": "Memory avg / peak",
  "pingAvg": "Ping avg",
  "lvlError": "Error",
  "lvlWarn": "Warning",
  "fAll": "All",
  "fErrors": "Errors",
  "fWarnings": "Warnings",
  "level": "Level",
  "last24h": "Last 24 h:",
  "nErrors": "{n} error | {n} errors",
  "nWarnings": "{n} warning | {n} warnings",
  "deviceLog": "Device log",
  "noneErrors": "No errors reported in the last {days} days. 🎉",
  "noneWarnings": "No warnings reported in the last {days} days. 🎉",
  "noneBoth": "No errors or warnings reported in the last {days} days. 🎉",
  "stackTrace": "Stack trace",
  "pageKept": "Page {n} · kept {days} days",
  "deleteInteractionQ": "Delete the interaction “{name}”?",
  "interactionDeleted": "Interaction deleted",
  "interactionSaved": "Interaction saved · the player picks it up on its next sync",
  "newInteraction": "+ New interaction",
  "interHint": "Let viewers tap the screen — or press a key on the TV remote — to open content or a web page.",
  "noInteractions": "No interactions on this player yet.",
  "fromCampaigns": "From campaigns on this player",
  "fromCampaignsHint": "These apply while their campaign is on screen, and are checked before this player's own. Edit them in the campaign.",
  "thisPlayer": "this player"
};
const ar: typeof en = {
  "unpairedTitle": "لا يوجد جهاز مقترن",
  "unpairedBody": "هذا المشغل غير مرتبط بشاشة، لذلك لا يُعرض عليه شيء. اقرن جهازًا لعرض محتواه؛ تظهر حالته وتفاصيله هنا بعد اتصاله.",
  "notPaired": "غير مقترن",
  "searchPlays": "ابحث بالعنصر أو التخطيط",
  "fRange": "الفترة",
  "r24h": "آخر 24 ساعة",
  "r7d": "آخر 7 أيام",
  "r30d": "آخر 30 يومًا",
  "r90d": "آخر 90 يومًا",
  "fAllTypes": "كل أنواع التشغيل",
  "fKind": "نوع المحتوى",
  "fAllKinds": "كل المحتوى",
  "k_video": "فيديوهات",
  "k_image": "صور",
  "k_widget": "تطبيقات",
  "k_app": "تطبيقات مخصصة",
  "k_pdf": "ملفات PDF",
  "k_composition": "تصاميم",
  "clearFilters": "مسح عوامل التصفية",
  "nPlays": "لا مرات تشغيل | مرة تشغيل واحدة | مرتا تشغيل | {n} مرات تشغيل | {n} مرة تشغيل | {n} مرة تشغيل",
  "nPlaysCapped": "+{n} مرة تشغيل",
  "noPlaysMatch": "لا توجد مرات تشغيل مطابقة. جرّب بحثًا أو فترة أو تصفية أخرى.",
  "tStatus": "حالة المشغل",
  "tPublished": "قائمة التشغيل",
  "tActivity": "نشاط المشغل",
  "tResources": "استخدام الموارد",
  "tLogs": "الأخطاء والتحذيرات",
  "tLive": "التحكم المباشر",
  "tInteractivity": "التفاعل",
  "tSettings": "إعدادات المشغل",
  "tManifest": "البيان",
  "backPlayers": "→ المشغلات",
  "player": "مشغل",
  "downloadingPct": "جارٍ تنزيل المحتوى {pct} %",
  "downloadingLine": "جارٍ تنزيل المحتوى: {pct} % · {done} من {total} ملفات · {got} من {size}",
  "online": "متصل",
  "offline": "غير متصل",
  "sections": "أقسام المشغل",
  "dH": "{d} ي {h} س",
  "hM": "{h} س {m} د",
  "m": "{m} د",
  "s": "{s} ث",
  "never": "أبدًا",
  "justNow": "الآن",
  "ago": "منذ {d}",
  "fb_no_manifest": "لم يُنشر محتوى بعد",
  "fb_no_active_schedule": "لا شيء مجدول الآن",
  "fb_assets_pending": "ما زال المحتوى قيد التنزيل",
  "fb_asset_verification_failed": "فشل التحقق من ملف",
  "fb_decoder_error": "خطأ في فك الترميز",
  "fb_storage_full": "التخزين ممتلئ",
  "aName": "اسم المشغل",
  "aModel": "طراز الجهاز",
  "aOs": "نظام التشغيل",
  "aVersion": "إصدار المشغل",
  "aResolution": "دقة الشاشة",
  "aMac": "عنوان MAC",
  "aNotReported": "لم يُبلّغ عنه نظام التشغيل",
  "aLocalIp": "عنوان IP المحلي",
  "aPublicIp": "عنوان IP العام",
  "aPaired": "الإقران",
  "aNotPaired": "غير مقترن",
  "setupTitle": "إعداد الجهاز",
  "setupAllSet": "كل شيء جاهز",
  "setupMissing": "إذن واحد غير مسموح | {n} أذونات غير مسموحة",
  "setupUnknown": "تطبيق هذا المشغّل لا يُبلغ عن إعداده بعد. حدّث التطبيق على الشاشة لعرضه هنا.",
  "permAllowed": "مسموح",
  "permNotAllowed": "غير مسموح",
  "setupNeeds": "يحتاج إلى انتباه",
  "fixDirect": "السماح عن بُعد",
  "fixAsk": "اطلب على الشاشة",
  "fixDirectHint": "يُطبَّق على المشغل الآن — لا حاجة لوجود أحد.",
  "fixAskHint": "يعرض طلب Android على الشاشة؛ يضغط شخص هناك «سماح».",
  "fixApplying": "جارٍ التطبيق… (يتحدث خلال دقيقة)",
  "fixWaiting": "بانتظار قبول شخص عند الشاشة…",
  "fixAllDirect": "إصلاح الكل عن بُعد",
  "fixAllAsk": "إصلاح الكل على الشاشة",
  "fixSentDirect": "تم الإرسال: يقوم المشغل بالسماح الآن",
  "fixSentAsk": "تم الإرسال: الطلب على الشاشة — يجب أن يقبله شخص هناك",
  "fixFailed": "تعذّر الوصول إلى المشغل",
  "setupOk": "مسموح",
  "setupImpact": "ماذا يعني ذلك:",
  "setupHowFix": "طريقة الإصلاح:",
  "perm_fix_capture": "ابدأ البث المباشر ثم اطلب من شخص عند الشاشة الضغط على «ابدأ الآن» في المربع الذي يظهر. وهي أيضًا خطوة في معالج الإعداد.",
  "perm_root": "صلاحيات الجذر (تُستخدم للتحديث الصامت وإعادة التشغيل والعمل تلقائيًا)",
  "perm_root_off": "",
  "perm_remoteTouch": "يمكن للبث المباشر لمس الشاشة بالكامل",
  "perm_remoteTouch_off": "النقرات والسحب في البث المباشر تصل إلى Displaro فقط، لا إلى التطبيقات الأخرى أو الشاشة الرئيسية.",
  "perm_fullScreenCapture": "يعرض البث المباشر الشاشة بالكامل",
  "perm_fullScreenCapture_off": "يعرض البث المباشر Displaro فقط. يمكن لشخص عند الشاشة السماح بالتقاط الشاشة كاملة من معالج الإعداد (يطلب Android ذلك مجددًا بعد إعادة التشغيل).",
  "perm_autoStart": "يعمل تلقائيًا بعد إعادة التشغيل أو انقطاع الكهرباء",
  "perm_autoStart_off": "بعد انقطاع الكهرباء أو إعادة التشغيل تبقى الشاشة على أندرويد حتى يفتح أحدهم Displaro (يظهر تذكير «اضغط للاستئناف» إذا كانت الإشعارات مسموحة).",
  "perm_batteryUnrestricted": "لا يضعه أندرويد في وضع السكون",
  "perm_batteryUnrestricted_off": "قد يوقف أندرويد Displaro مؤقتًا أو نهائيًا أثناء التشغيل الطويل لتوفير الطاقة على بعض الأجهزة.",
  "perm_installUpdates": "يثبّت التحديثات بلمسة واحدة",
  "perm_installUpdates_off": "عند وصول إصدار جديد يجب على شخص عند الشاشة أولًا السماح لـ Displaro بتثبيت التطبيقات قبل التحديث.",
  "perm_notifications": "يمكنه عرض تذكير «اضغط للاستئناف»",
  "perm_notifications_off": "إذا لم يستطع Displaro العودة تلقائيًا فلن يظهر أي تذكير على الشاشة.",
  "perm_deviceOwner": "وضع الكشك (مالك الجهاز)",
  "perm_deviceOwner_off": "إعادة التشغيل عن بُعد غير متاحة، ويمكن للمستخدمين الخروج من المشغّل بزر الشاشة الرئيسية، وتحتاج تحديثات التطبيق إلى لمسة على الشاشة.",
  "perm_fix_wizard": "أصلحه على الشاشة: أعد تشغيل Displaro واختر «سماح» في الإعداد الذي يظهر.",
  "perm_fix_owner": "يُعدّ مرة واحدة على جهاز أُعيد ضبطه باستخدام رمز QR لإعداد الكشك، أو اطلب من المُركِّب جهازًا مُعدًّا مسبقًا.",
  "about": "عن المشغل",
  "idLabel": "المعرّف {id}",
  "time": "الوقت",
  "localTime": "التوقيت المحلي عند الشاشة · {tz}",
  "lastSeen": "آخر ظهور",
  "uptime": "مدة التشغيل",
  "lastSync": "آخر مزامنة للمحتوى",
  "lastCheck": "آخر فحص للبيان",
  "other": "تفاصيل أخرى",
  "noHeartbeat": "لم تصل نبضة بعد — تظهر التفاصيل عندما يتصل المشغل.",
  "connection": "الاتصال",
  "onlineDot": "● متصل",
  "copy": "نسخ",
  "waitingPlays": "لا شيء | تشغيل واحد | {n} عمليات تشغيل",
  "lastSent": "آخر إرسال {ago} · يُرفع كل 15 دقيقة",
  "neverSent": "لم يُستلم شيء خلال آخر 7 أيام",
  "copied": "تم النسخ",
  "offlineDot": "○ غير متصل",
  "playback": "التشغيل",
  "playing": "يعرض المحتوى المجدول",
  "notOnScreen": "لكن تطبيقًا آخر أو الشاشة الرئيسية أمامه: الشاشة لا تعرضه",
  "fallbackReel": "⚠ العرض الاحتياطي",
  "starting": "قيد البدء",
  "content": "المحتوى",
  "upToDate": "محدّث",
  "pending": "r{rev} قيد الانتظار",
  "mediaFiles": "ملفات الوسائط",
  "filesLine": "{v} تم التحقق · {p} قيد التنزيل · {f} فشل",
  "storage": "التخزين",
  "freeOf": "{free} متاح من {total}",
  "storagePct": "التخزين مستخدم بنسبة {pct}٪",
  "contentTooBig": "حجم محتواه {need}، ولا يتسع هذا المشغّل إلا لنحو {capacity}. صغّر المحتوى أو استخدم مشغّلًا بسعة تخزين أكبر.",
  "appMemory": "ذاكرة التطبيق",
  "lowMemory": "· ⚠ ذاكرة منخفضة",
  "network": "الشبكة",
  "noInternet": " (بلا إنترنت)",
  "power": "الطاقة",
  "mains": "يعمل بالكهرباء",
  "charging": " · يشحن",
  "unsent": "عمليات تشغيل بانتظار الرفع",
  "buffered": "{n} مخزنة على الجهاز",
  "coordsBoth": "أدخل خط العرض وخط الطول معًا (أو اتركهما فارغين).",
  "latRange": "يجب أن يكون خط العرض بين −90 و90.",
  "lngRange": "يجب أن يكون خط الطول بين −180 و180.",
  "saved": "تم الحفظ",
  "locationSaved": "تم حفظ الموقع",
  "savedNextSync": "تم الحفظ · يطبّقه المشغل عند المزامنة التالية",
  "deletePrompt": "حذف «{name}» نهائيًا؟ تُحذف قائمة محتواه وإعداداته ويُحرَّر مقعده.\n\nاكتب اسم المشغل للتأكيد:",
  "nameMismatch": "الاسم غير مطابق؛ لم يُحذف شيء",
  "deleted": "تم حذف «{name}»",
  "sGeneral": "عام",
  "sLocation": "الموقع",
  "sSchedule": "جدول العمل",
  "sDisplay": "العرض",
  "sSound": "الصوت",
  "sDevice": "الجهاز",
  "discard": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
  "loading": "جارٍ التحميل…",
  "settingsSections": "أقسام الإعدادات",
  "saving": "جارٍ الحفظ…",
  "save": "حفظ",
  "playerName": "اسم المشغل",
  "timeZone": "المنطقة الزمنية",
  "tzHint2": "تعمل ساعات العمل والقيود والساعات بهذه المنطقة الزمنية.",
  "groupsTags": "المجموعات والوسوم",
  "noGroup": "بلا مجموعة",
  "editInPlayers": "التعديل في المشغلات",
  "notSet": "غير محدد",
  "latitude": "خط العرض",
  "longitude": "خط الطول",
  "locFromDevice": "من جهاز المشغّل (±{acc})",
  "locFromIp": "تقدير من عنوان الإنترنت (تقريبي)",
  "locationTitle": "الموقع",
  "locApprox": "منطقة تقريبية",
  "changeLocation": "تغيير الموقع",
  "setLocation": "تحديد الموقع",
  "noLocationYet": "لا يوجد موقع بعد. يُبلغ المشغّل عنه عندما يستطيع، أو يمكنك تحديده في إعدادات المشغّل.",
  "locManual": "مُدخل يدويًا",
  "locWaiting": "يتبع المشغّل (بانتظار أن يُبلغ عن موقعه)",
  "useDeviceLocation": "استخدم موقع المشغّل بدلًا من ذلك",
  "locationFollows": "أصبح الموقع يتبع المشغّل",
  "locAutoHint": "يُضبط تلقائيًا من جهاز المشغّل (أو تقريبيًا من عنوان الإنترنت)؛ والموقع المُدخل هنا يبقى حتى تعيده للمشغّل.",
  "perm_location": "يشارك موقعه",
  "perm_location_off": "لا يمكن ضبط الموقع بدقة تلقائيًا: يُقدَّر من عنوان الإنترنت (غالبًا بفارق عدة كيلومترات) ما لم تُدخله يدويًا.",
  "locHint": "تستخدمه تطبيقات أوقات الصلاة والطقس المضبوطة على «موقع المشغل».",
  "noDevice": "لا يوجد جهاز مقترن بهذا المشغل.",
  "cmdSent": "{what}: أُرسل إلى المشغّل",
  "cmdDone": "{what}: تم",
  "cmdFailed": "لم ينجح {what}",
  "cmdSending": "جارٍ الإرسال…",
  "repairHere": "إعادة الإقران بجهاز جديد",
  "pairHere": "إقران جهاز",
  "deviceCmdHint": "إعادة التشغيل ومسح الذاكرة المؤقتة يعملان على كل الأجهزة؛ وإعادة تشغيل الجهاز بالكامل تحتاج وضع الكشك أو صلاحيات الجذر. لمشاهدة الشاشة مباشرة:",
  "openLive": "التحكم المباشر",
  "deviceActions": "إعادة التشغيل · مسح الذاكرة المؤقتة · العرض المباشر",
  "repairHw": "إعادة الإقران بجهاز جديد (في المشغلات ← تعديل)",
  "pairInPlayers": "إقران جهاز (في المشغلات ← تعديل)",
  "deleteNote": "يؤدي الحذف إلى إزالة هذا المشغل وقائمة محتواه وإعداداته وتحرير مقعده. لا يمكن التراجع عن ذلك.",
  "deletePlayer": "حذف المشغل…",
  "ptPlayer": "منشور على المشغل",
  "ptGroup": "من مجموعة",
  "ptTag": "من وسم",
  "ptRemoved": "أُزيل النشر",
  "ptPlayerHint": "شُغّل لأنه منشور مباشرة على هذا المشغل.",
  "ptGroupHint": "شُغّل لأنه منشور على مجموعة مشغلات ينتمي إليها هذا المشغل.",
  "ptTagHint": "شُغّل لأنه منشور على وسم يحمله هذا المشغل.",
  "ptRemovedHint": "حدث هذا التشغيل، لكن النشر الذي أرسله إلى هنا لم يعد موجودًا: أُلغي نشر العنصر أو نُشر من جديد، أو خرج المشغل من تلك المجموعة أو الوسم. ما زال التشغيل يُحتسب في التقارير.",
  "activityView": "عرض النشاط",
  "events": "الأحداث والمشكلات",
  "playbackTab": "التشغيل",
  "playerActivity": "نشاط المشغل",
  "popTimes": "إثبات العرض الذي أبلغ عنه الجهاز · الأوقات بتوقيت {tz}",
  "playerTz": "المنطقة الزمنية للمشغل",
  "refresh": "تحديث",
  "noPlayback": "لم يُبلّغ عن أي عرض بعد. يخزّن المشغل إثبات العرض دون اتصال ويرفعه عند اتصاله.",
  "cAsset": "اسم العنصر",
  "cType": "نوع التشغيل",
  "cDate": "التاريخ",
  "cTime": "الوقت",
  "cDuration": "المدة",
  "cLayout": "التخطيط",
  "deletedAsset": "عنصر محذوف",
  "page": "الصفحة {n}",
  "newer": "→ الأحدث",
  "older": "الأقدم ←",
  "published": "تم النشر.",
  "scene": "مشهد",
  "layout": "تخطيط",
  "customAppFeeds": "تطبيق مخصص · لا مصادر | تطبيق مخصص · مصدر واحد | تطبيق مخصص · مصدران | تطبيق مخصص · {n} مصادر | تطبيق مخصص · {n} مصدرًا | تطبيق مخصص · {n} مصدر",
  "recompile": "إعادة التجميع والنشر",
  "settingsIn": "الاسم والموقع والإعدادات موجودة في",
  "noManifest": "لم يُنشر بيان لهذه الشاشة بعد. ستعرض العرض الاحتياطي المضمّن حتى يُنشر.",
  "revisionTitle": "مراجعة البيان {n}",
  "verified": "تم التحقق",
  "canvas": "اللوحة",
  "media": "الوسائط",
  "nothingScheduled": "لا شيء مجدول: تعرض الشاشة العرض الاحتياطي المضمّن.",
  "entersWith": "يدخل بـ {tr}",
  "inSequence": "{len} في التسلسل",
  "nItemsZone": "{role} · {n} عنصر",
  "loop": "التكرار",
  "nothingPublished": "لم يُنشر شيء — العرض الاحتياطي المضمّن.",
  "item": "عنصر",
  "restricted": "مقيّد",
  "playsOnce": "يُعرض مرة واحدة ويبقى آخر عنصر.",
  "peak": "الذروة",
  "samples": "العينات",
  "slowest": "الأبطأ",
  "offlineSamples": "عينات دون اتصال",
  "nOfM": "{n} من {m}",
  "ms": "{n} م.ث",
  "cpu": "المعالج",
  "memory": "الذاكرة",
  "disk": "القرص",
  "per5": "{what} لكل ٥ دقائق · آخر ٢٤ ساعة",
  "perHour": "{what} لكل ساعة · آخر ٧ أيام",
  "timeRange": "النطاق الزمني",
  "last24": "آخر ٢٤ ساعة",
  "last7": "آخر ٧ أيام",
  "sampledEvery": "تُؤخذ العينات كل دقيقة على الجهاز · تُحفظ {days} يومًا · الأوقات بتوقيت {tz}",
  "playerTime": "توقيت المشغل",
  "noSamples": "لا توجد عينات موارد في هذه الفترة. ترفع المشغلات المقاييس على دفعات عند اتصالها — عد لاحقًا بعد أن تتصل الشاشة.",
  "peakIn": "الذروة في الفترة: {v}",
  "connectivity": "الاتصال",
  "offlineWarn": "⚠ غير متصل",
  "onlinePct": "متصل في {pct}٪ من العينات",
  "stale": "آخر عينة {ago} ({at}) — قد يكون المشغل غير متصل أو مطفأ.",
  "cpuUsage": "استخدام المعالج",
  "average": "المتوسط",
  "ram": "الذاكرة (RAM)",
  "diskUsage": "استخدام القرص",
  "highest": "الأعلى",
  "pingTitle": "الاتصال (ذهابًا وإيابًا إلى الخادم)",
  "avgLatency": "متوسط زمن الاستجابة",
  "showTable": "عرض جدول البيانات",
  "hideTable": "إخفاء جدول البيانات",
  "periodStart": "بداية الفترة",
  "cpuAvgPeak": "المعالج متوسط / ذروة",
  "memAvgPeak": "الذاكرة متوسط / ذروة",
  "pingAvg": "متوسط الاستجابة",
  "lvlError": "خطأ",
  "lvlWarn": "تحذير",
  "fAll": "الكل",
  "fErrors": "الأخطاء",
  "fWarnings": "التحذيرات",
  "level": "المستوى",
  "last24h": "آخر ٢٤ س:",
  "nErrors": "لا أخطاء | خطأ واحد | خطآن | {n} أخطاء | {n} خطأً | {n} خطأ",
  "nWarnings": "لا تحذيرات | تحذير واحد | تحذيران | {n} تحذيرات | {n} تحذيرًا | {n} تحذير",
  "deviceLog": "سجل الجهاز",
  "noneErrors": "لم تُبلّغ أخطاء في آخر {days} يومًا. 🎉",
  "noneWarnings": "لم تُبلّغ تحذيرات في آخر {days} يومًا. 🎉",
  "noneBoth": "لم تُبلّغ أخطاء أو تحذيرات في آخر {days} يومًا. 🎉",
  "stackTrace": "تتبّع المكدس",
  "pageKept": "الصفحة {n} · تُحفظ {days} يومًا",
  "deleteInteractionQ": "حذف التفاعل «{name}»؟",
  "interactionDeleted": "تم حذف التفاعل",
  "interactionSaved": "تم حفظ التفاعل · يستلمه المشغل عند المزامنة التالية",
  "newInteraction": "+ تفاعل جديد",
  "interHint": "دع المشاهدين يلمسون الشاشة — أو يضغطون زرًا في جهاز التحكم — لفتح محتوى أو صفحة ويب.",
  "noInteractions": "لا توجد تفاعلات على هذا المشغل بعد.",
  "fromCampaigns": "من الحملات على هذا المشغل",
  "fromCampaignsHint": "تنطبق هذه أثناء عرض حملتها، وتُفحص قبل تفاعلات هذا المشغل. عدّلها في الحملة.",
  "thisPlayer": "هذا المشغل"
};
export default { en, ar };
